import { Separator } from '@/components/atoms/Seperator';

import type { InquiryItem } from '@/types/api';
import moment from 'moment';
import { TimeBadge } from './TimeBadge';

const InquiryProfile = ({ inquiry }: { inquiry: InquiryItem }) => {
  return (
    <div className="flex min-w-0 flex-wrap items-center gap-x-[12px] gap-y-[6px] text-gr-800">
      <MarketName inquiry={inquiry} />
      <div className="flex shrink-0 items-center gap-[12px]">
        <Separator orientation="vertical" className="h-[18px] w-[1px] bg-gr-200" />
        <InquiryDate inquiry={inquiry} />
      </div>
      <InquiryBadge inquiry={inquiry} />
    </div>
  );
};

export default InquiryProfile;

export const MarketName = ({ inquiry }: { inquiry: InquiryItem }) => {
  return (
    <div className="flex flex-shrink-0 items-center gap-1">
      <img src={inquiry.MarketIconUrl} alt="" className="h-5 w-5" />
      <span className="text-gr-800 Body5M14">{inquiry.StoreName}</span>
    </div>
  );
};

const InquiryDate = ({ inquiry }: { inquiry: InquiryItem }) => {
  const dateObj = new Date(inquiry.InquiryDate);
  const yy = String(dateObj.getFullYear()).slice(2, 4);
  const mm = String(dateObj.getMonth() + 1).padStart(2, '0');
  const dd = String(dateObj.getDate()).padStart(2, '0');
  const hh = String(dateObj.getHours()).padStart(2, '0');
  const min = String(dateObj.getMinutes()).padStart(2, '0');

  return <span className="whitespace-nowrap Body5M14">{`${yy}/${mm}/${dd} ${hh}:${min}`}</span>;
};

const InquiryBadge = ({ inquiry }: { inquiry: InquiryItem }) => {
  // 처리완료 여부(답변완료 등)
  const isCompleted = inquiry.CheckedYn === 'Y';

  // 문의 등록 시간
  const inquiryDate = moment(inquiry.InquiryDate);
  const now = moment();
  const diffHours = now.diff(inquiryDate, 'hours');

  // 긴급문의 여부
  const isUrgentInquiry = inquiry.QnaTypeCode === '긴급문의';

  // 경과 시간 뱃지
  let timeBadge = null;
  if (isCompleted) {
    timeBadge = (
      <TimeBadge color="gr">
        처리완료
      </TimeBadge>
    );
  } else if (diffHours >= 24) {
    timeBadge = (
      <TimeBadge color="red">
        24시간 경과
      </TimeBadge>
    );
  } else if (diffHours >= 1) {
    timeBadge = (
      <TimeBadge color="point">
        {diffHours}시간 경과
      </TimeBadge>
    );
  } else {
    timeBadge = (
      <TimeBadge color="point">
        방금 전
      </TimeBadge>
    );
  }

  // 긴급문의 뱃지
  const urgentBadge = isUrgentInquiry ? (
    <TimeBadge color="red">
      긴급문의
    </TimeBadge>
  ) : null;

  return (
    <span className="flex shrink-0 items-center gap-1">
      {urgentBadge}
      {timeBadge}
    </span>
  );
};
